import styles from './informacaoBasica.module.scss';
function InformacaoBasica({ titulo, conteudo, large }: { titulo: string; conteudo: string; large?: boolean }) {
  return (
    <>
      {!!conteudo && (
        <div className={large ? styles['item-large'] : styles.item} tabIndex={0} aria-label={`${titulo}: ${conteudo}`}>
          <div className={styles.titulo}> {titulo} </div>
          <p className={styles.conteudo}> {conteudo} </p>
        </div>
      )}
    </>
  );
}

export default InformacaoBasica;
